import relatorioProducao from './relatorioProducaoRepository'
import parametrizacao from './parametrizacaoRepository'
import jornada from './jornadaRepository'
import agendamento from './agendamentoRepository'
import fechamento from './fechamentoRepository'
import lancamento from './lancamentoRepository'
import impressao from './impressaoRepository'
import alteracaoExameFinalizado from './alteracaoExameFinalizadoRepository'
import reimpressaoResultado from './reimpressaoResultadoRepository'
import relatorioExameStatus from './relatorioExameStatusRepository'
import alteracaoResultadoLancamento from './alteracaoResultadoLancamentoRepository'
import listagemExameAgendado from './listagemExamesAgendadosRepository'
import exameAgendadoRealizado from './exameAgendadoRealizadoRepository'
import agendamentoRetroativo from './agendamentoRetroativoRepository'
import relatorioCotaProfissional from './relatorioCotaProfissionalRepository'
import relatorioFinanceiroExame from './relatorioFinanceiroExameRepository'
import reagendamentoExame from './reagendamentoExameRepository'
import confirmacaoExame from './confirmacaoExameRepository'

export default baseUrl => {
    baseUrl = `${baseUrl}/exame-imagem`

    return {
        relatorioProducao:relatorioProducao(baseUrl),
        parametrizacao: parametrizacao(baseUrl),
        jornada: jornada(baseUrl),
        agendamento: agendamento(baseUrl),
        fechamento: fechamento(baseUrl),
        lancamento: lancamento(baseUrl),
        impressao: impressao(baseUrl),
        alteracaoExameFinalizado: alteracaoExameFinalizado(baseUrl),
        reimpressaoResultado: reimpressaoResultado(baseUrl),
        relatorioExameStatus: relatorioExameStatus(baseUrl),
        alteracaoResultadoLancamento: alteracaoResultadoLancamento(baseUrl),
        listagemExameAgendado: listagemExameAgendado(baseUrl),
        exameAgendadoRealizado: exameAgendadoRealizado(baseUrl),
        agendamentoRetroativo: agendamentoRetroativo(baseUrl),
        relatorioCotaProfissional: relatorioCotaProfissional(baseUrl),
        relatorioFinanceiroExame: relatorioFinanceiroExame(baseUrl),
        reagendamentoExame: reagendamentoExame(baseUrl),
        confirmacaoExame: confirmacaoExame(baseUrl),
    }
}
